(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("aws_amplify_pubsub"));
	else if(typeof define === 'function' && define.amd)
		define("aws_amplify_datastore", ["aws_amplify_pubsub"], factory);
	else if(typeof exports === 'object')
		exports["aws_amplify_datastore"] = factory(require("aws_amplify_pubsub"));
	else
		root["aws_amplify_datastore"] = factory(root["aws_amplify_pubsub"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__aws_amplify_pubsub__) {
return 